import { FieldPattern } from '..';

import { FormFieldsType } from '../../../../../shared/types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class FileUploaderFieldModel extends FormFieldWithInitialValue {
  readonly type: string = 'file';
  fieldType!: string;
  isFieldDisabled: boolean;
  pathToUpload: string;
  aclType: string;
  maxSizeToUploadInMb: number;

  constructor(
    fileUploaderField: FormFieldsType,
    initialValue = '',
    fieldType = 'file'
  ) {
    super(fileUploaderField, initialValue);
    this.fieldType = fieldType;
    this.isFieldDisabled = false;
    this.shouldShowLabel = fileUploaderField.shouldShowLabel;
    this.aclType = fileUploaderField.acl_type?.toLowerCase() ?? '';
    this.pathToUpload = fileUploaderField.path_to_upload ?? '';
    this.maxSizeToUploadInMb = fileUploaderField.max_size_to_upload_in_mb ?? 5;
  }
  match<T>(p: FieldPattern<T>): T {
    return p.FileUploaderField(this);
  }
}

export default FileUploaderFieldModel;
